// import axios from "axios";
// import { saveLog } from "./logger";

// // Generic API wrapper with auto logging
// export const apiWithLog = async ({
//   method,
//   url,
//   data = null,
//   module,
//   action, // A / E / D
// }) => {
//   try {
//     let response;

//     if (method === "GET") {
//       response = await axios.get(url);
//     }

//     if (method === "POST") {
//       response = await axios.post(url, data);
//     }

//     if (method === "PUT") {
//       response = await axios.put(url, data);
//     }

//     if (method === "DELETE") {
//       response = await axios.delete(url);
//     }

//     // ===== SUCCESS =====
//     if (response.data?.success) {
//       saveLog({
//         module,
//         action,
//         status: "S",
//       });
//     } else {
//       saveLog({
//         module,
//         action,
//         status: "E",
//       });
//     }

//     return response;

//   } catch (error) {
//     // ===== ERROR =====
//     saveLog({
//       module,
//       action,
//       status: "E",
//     });

//     throw error;
//   }
// };





import axios from "axios";
import { saveLog } from "./logger";
import { networkManager } from "./networkManager";

// Active in-flight request tracker to prevent double submissions
const activeRequests = new Set();

/**
 * Generate a deterministic signature for request deduplication
 */
function getRequestSignature(method, url, data) {
  let serializedData = "";
  if (data instanceof FormData) {
    const entries = [];
    data.forEach((val, key) => {
      if (val instanceof File) {
        entries.push(`${key}:${val.name}:${val.size}`);
      } else {
        entries.push(`${key}:${val}`);
      }
    });
    serializedData = entries.sort().join("&");
  } else if (data instanceof URLSearchParams) {
    serializedData = data.toString();
  } else if (typeof data === "object" && data !== null) {
    try {
      serializedData = JSON.stringify(data);
    } catch {
      serializedData = String(data);
    }
  } else if (data) {
    serializedData = String(data);
  }
  return `${(method || "").toUpperCase()}|${url}|${serializedData}`;
}

export const apiWithLog = async ({
  method,
  url,
  data = null,
  module,
  action, // A / E / D
  headers = {},
}) => {
  const m = (method || "GET").toUpperCase();
  const isMutating = ["POST", "PUT", "DELETE"].includes(m);
  const requestKey = isMutating ? getRequestSignature(m, url, data) : null;

  if (isMutating && requestKey) {
    if (activeRequests.has(requestKey)) {
      console.warn("Duplicate in-flight request prevented:", m, url);
      const err = new Error("This request is already processing. Please wait.");
      err.isDuplicate = true;
      throw err;
    }
    activeRequests.add(requestKey);
  }

  try {
    let response;
    const isFormData = data instanceof FormData;
    const finalHeaders = isFormData ? undefined : headers;

    // ===== API CALL =====
    if (m === "POST") {
      response = await axios.post(url, data, { headers: finalHeaders });
    } else if (m === "PUT") {
      response = await axios.put(url, data, { headers: finalHeaders });
    } else if (m === "DELETE") {
      response = await axios.delete(url, { headers: finalHeaders });
    } else if (m === "GET") {
      response = await axios.get(url, { headers: finalHeaders });
    }

    // ===== SUCCESS RULE =====
    // If request reached here → API did NOT throw error
    // and status is 2xx → treat as Success
    const isSuccess = response && response.status >= 200 && response.status < 300;

    await saveLog({
      module,
      action,
      status: isSuccess ? "S" : "E",
    });

    return response;
  } catch (error) {
    if (error?.message === "Network Error" || error?.code === "ERR_NETWORK" || (!error?.response && typeof navigator !== "undefined" && !navigator.onLine)) {
      try {
        networkManager.checkConnectivity();
      } catch {
        // Ignore
      }
    }

    // Only log actual failures, not client-side prevented duplicates
    if (!error?.isDuplicate) {
      await saveLog({
        module,
        action,
        status: "E",
      });
    }

    throw error;
  } finally {
    // Release the active lock once request completes (success or failure)
    if (isMutating && requestKey) {
      activeRequests.delete(requestKey);
    }
  }
};